module.exports = " <div class=vc-infinite-scroll> <circular v-show=loading :size=24 color=carbon></circular> <span v-show=loading class=vc-infinite-scroll-text>正在加载。。。</span> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/infiniteScroll.vue
 ** module id = 451
 ** module chunks = 1
 **/